import React, { useContext } from 'react';
import { useTranslation } from "react-i18next";
import ReactWhatsapp from "react-whatsapp";

import PeriodicMaintenance from "./subpages/periodicMaintenance";
import MaintenanceContext from "./maintenanceContext";
import Breadcrumb from "../../components/__simple/breadcrumb";
import ServiceHeaderBanner from "./components/serviceHeaderBanner";
import "./periodicMaintenancePage.scss";

const PeriodicMaintenancePage = () => {
    const { t: trans, i18n } = useTranslation(["info", "navbar", "common"]);
    const { handleServiceOrder } = useContext(MaintenanceContext);
    const lang = i18n.language || "ar";


    const handleReserve = () => {
        handleServiceOrder({
            showPopup: true,
            type: "sub2",
            main: "0a5e145a-bf3f-4a8e-aa7b-d8f0a1e0d9b0",
            sub1: "eb199b7e-55be-4ac8-b465-9a110b415ca8",
            sub2: "2b995873-d703-47d8-9f58-f1df7f1e3979"
        });
    };

    return (
        <div className="periodic-maintenance-page">
            <ServiceHeaderBanner />
            <div className="container">
                <Breadcrumb className="mt-16"
                    links={[
                        { name: trans("info:maintenance"), path: "/maintenance" },
                        { name: trans("navbar:periodic_maintenance") }
                    ]}
                />
            </div>

            <div className="container mt-20 mb-36">
                <PeriodicMaintenance />

                <div className="specs-fcta mt-20">
                    <div className="specs-fcta-text">
                        <h3>{trans("info:ready_to_decide", "جاهز لاتخاذ قرارك؟")}</h3>
                        <p>{lang === "ar" ? "    تواصل مع مستشار الصيانة للحصول على المساعدة أو إحجز موعد " : "Book an appointment or contact our maintenance advisor for assistance "}</p>
                    </div>
                    <div className="specs-fcta-btns">
                        <button
                            className="vh-cta wa test-wa"
                            onClick={handleReserve}
                            style={{ border: 'none' }}
                        >
                            <img src="/assets/icons/services/maintenance-periodic.svg" alt="" style={{ width: '20px', height: '20px', filter: 'brightness(0) invert(1)' }} />
                            {trans("info:reserve")} {trans("navbar:periodic_maintenance")}
                        </button>

                        <ReactWhatsapp
                            className="vh-cta wa quote-wa"
                            number="+966920018996"
                            message={lang === "ar" ?
                                `مرحباً، أود الاستفسار عن الصيانة الدورية` :
                                `Hello, I would like to inquire about periodic maintenance`}
                        >
                            <svg viewBox="0 0 24 24" width="20" height="20"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z" stroke="currentColor" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
                            {lang === "ar" ? "تحدث مع مستشار" : "Talk to advisor"}
                        </ReactWhatsapp>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PeriodicMaintenancePage;
